
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import utilStyles from 'styles/utils.module.scss';
import styles from 'pages/events/[eid]/index.module.scss';
import NavigationLayout from "components/layout/NavigationLayout";
import { useRouter } from "next/router";
import { useContext, useEffect, useMemo, useRef, useState } from "react";
import TitleBar from "components/layout/TitleBar";
import { Axios, defaultCacheOption } from "api";
import * as Sentry from "@sentry/nextjs";
import { captureException, captureMessage } from "@sentry/nextjs";
import Loading from "components/Loading";
import FullButton from "components/buttons/FullButton";
import { Col, Row } from "react-bootstrap";
import ProductListCard from "components/cards/ProductListCard";
import classNames from "classnames";
import { KEY_TYPE_GIFT, KEY_TYPE_PROMOTION } from "pages/events/index";
import { customAlert, customConfirm, formatDate, getDaysLeft } from "common/utils";
import TruncateMarkup from "react-truncate-markup";
import Modal from "components/Modal";
import { getEventApplyRoute, getEventRoute, SITE_URL } from "common/const";
import UserContext from "context/AuthContext";
import ArrowDown from "images/icons/arrow_down.svg";
import ShareButton from "components/ShareButton";
import ShareIcon from "images/icons/share.svg";
import { LazyImage } from "components/sections/product/ProductInfoSection";
import StoreNavBar from "components/layout/NavBar/StoreNavBar";
import CategoryContext from "context/CategoryContext";
import { redirectToLogin } from "common/redirect";
import { toast } from "react-toastify";
import Head from "next/head";
import { SelfVerificationButton } from "pages/mypage/my-info";
import { EventDetailQuizList } from "components/layout/event/EventDetailQuizRow";
import Luck from "pages/events/[eid]/Luck";
import Fifo from "pages/events/[eid]/Fifo";
import Bok from "pages/events/[eid]/Bok";
import useTimer from "hooks/useTimer";
import EventDetailComponents from "components/event/EventDetailComponents";
import InfiniteScroll from "react-infinite-scroll-component";
import { EventDetailComponentsRef } from "components/event/EventDetailComponentsRef";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";
const STATUS_ANNOUNCED = '당첨자 발표';
const STATUS_IN_PROGRESS = '진행중';
const EventResultModal = ({ isModalOpen, close }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [winners, setWinners] = useState([]);
    const router = useRouter();
    const { t } = useTranslation('events-eid-index');
    useEffect(async () => {
        if (!router.query.eid) {
            return;
        }
        setIsLoading(true);
        try {
            const res = await Axios.get(`v1/events/${router.query.eid}/winners/`);
            if (res.status < 400) {
                setWinners(res.data.winner_nickname_list);
            }
            else {
                captureMessage(JSON.stringify(res.data));
                alert(res.data.display_message || t('EventDetail.fetchWinnerListFailed'));
            }
        }
        catch (e) {
            captureException(e);
            alert(t('EventDetail.fetchWinnerListFailed'));
        }
        finally {
            setIsLoading(false);
        }
    }, [router.query?.eid]);
    return (<Modal isOpen={isModalOpen} close={close} width={'100%'} height={'100%'}>
            <div className={classNames(utilStyles.sidePadding, utilStyles.topSticky, utilStyles.whiteBackground)}>
                <TitleBar title={t('EventResultModal.title')} isClose close={close} noTruncate/>
            </div>
            <div className={styles.modalContentContainer}>
                {isLoading ?
            <Loading />
            :
                <>
                            <span className={styles.modalTitle}>{t('EventDetail.thankYouForParticipating')}</span>
                            <span className={styles.modalSubTitle}>{t('EventDetail.pleaseParticipateInOtherEvents')}</span>
                            <Row>
                                {winners.map((e, idx) => {
                        return (<Col xs={6} key={idx}>
                                                <span className={styles.modalResultElem}>{e}</span>
                                            </Col>);
                    })}
                            </Row>
                        </>}
            </div>
        </Modal>);
};
const LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_IMAGE_SIZE = 'evt_dtl_bnr_img_size';
const LOCAL_STORAGE_KEY_EVENT_DETAIL_DETAIL_IMAGE_EXPANDED = 'evt_dtl_dtl_img_expanded';
const LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_DETAIL_SIZE = 'evt_dtl_dtl_img_size';
const defaultPaginationSize = 20;
const EventDetail = () => {
    const router = useRouter();
    const [isLoading, setIsLoading] = useState(false);
    const [event, setEvent] = useState(null);
    const [productList, setProductList] = useState([]);
    const [lastLuckReward, setLastLuckReward] = useState(null);
    const [bokInfo, setBokInfo] = useState({});
    const user = useContext(UserContext).user;
    const category = router.query.category;
    const categoryContext = useContext(CategoryContext);
    const { t } = useTranslation('events-eid-index');
    const additionalInfo = useRef({
        cursor: null,
        hasNext: false
    });
    const previousSizeInfo = useMemo(() => {
        if (typeof window === 'undefined')
            return {};
        const bannerImageSizeString = localStorage.getItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_IMAGE_SIZE);
        const detailImageExpandedString = localStorage.getItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_DETAIL_IMAGE_EXPANDED);
        const detailImageSizeString = localStorage.getItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_DETAIL_SIZE);
        const bannerImageSize = bannerImageSizeString ? JSON.parse(bannerImageSizeString) : {};
        const detailImageExpanded = detailImageExpandedString ? JSON.parse(detailImageExpandedString) : {};
        const detailImageSize = detailImageSizeString ? JSON.parse(detailImageSizeString) : {};
        return {
            bannerImageSize: bannerImageSize.stateKey === window.history.state.key ? bannerImageSize : {},
            detailImageExpanded: detailImageExpanded.stateKey === window.history.state.key ? detailImageExpanded.isExpanded : false,
            detailImageSizeArray: detailImageSize.stateKey === window.history.state.key ? detailImageSize.sizes : []
        };
    }, []);
    const [hasVoted, setHasVoted] = useState(false);
    const [voteResult, setVoteResult] = useState(null);
    const votePercentage = useMemo(() => {
        if (!voteResult)
            return {};
        const res = {};
        const target = Object.entries(voteResult || {}).filter(([k, v]) => {
            return !!v;
        });
        const total = target.reduce((acc, [k, v]) => {
            return acc + v;
        }, 0);
        let prevPercentages = 0;
        const list = target.map(([k, v], i) => {
            if (!total)
                return [k, 0];
            if (i !== target.length - 1) {
                const newVal = Math.round(v / total * 100);
                prevPercentages += newVal;
                return [k, newVal];
            }
            else {
                return [k, 100 - prevPercentages];
            }
        });
        return Object.fromEntries(list);
    }, [voteResult]);
    const getEventDetail = async () => {
        try {
            setIsLoading(true);
            const res = await Axios.get(`v1/events/${router.query.eid}`, {
                cache: defaultCacheOption
            });
            if (res.status < 400) {
                setLastLuckReward(res.data.last_luck_reward);
                setBokInfo(res.data.bok_info);
                setHasVoted(res.data.has_voted);
                setVoteResult(res.data.vote_result);
                setEvent(res.data.event);
            }
            else {
                alert(res.data.display_message || t('EventDetail.temporaryError'));
                captureMessage(JSON.stringify(res.data));
            }
        }
        catch (e) {
            alert(t('EventDetail.temporaryError'));
            captureException(e);
        }
        finally {
            setIsLoading(false);
        }
    };
    const fetchProductList = async () => {
        try {
            const event_id = router.query.eid;
            if (!event_id)
                return [];
            const categoryId = category ? category.split('_')[category.split('_').length - 1] : null;
            const param = {
                params: {
                    cursor: additionalInfo.current.cursor,
                    category_id: categoryId,
                    size: defaultPaginationSize
                }
            };
            const res = await Axios.get(`v1/events/${event_id}/products`, param);
            if (res.status < 400) {
                additionalInfo.current = {
                    cursor: res.data.cursor,
                    hasNext: !!res.data.cursor
                };
                setProductList(prev => {
                    const newProductList = JSON.parse(JSON.stringify(prev));
                    return [...newProductList, ...res.data.product_list];
                });
            }
        }
        catch (e) {
            console.error(e);
            captureException(e);
        }
    };
    useEffect(() => {
        if (!router.query.eid)
            return;
        localStorage.setItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_DETAIL_IMAGE_EXPANDED, JSON.stringify({
            stateKey: window.history.state.key,
            isExpanded: !!previousSizeInfo.detailImageExpanded || false
        }));
    }, [router.query]);
    const [isResultModalOpen, setIsResultModalOpen] = useState(false);
    useEffect(async () => {
        if (!router.isReady || !router.query.eid)
            return;
        additionalInfo.current = {
            cursor: null,
            hasNext: false
        };
        await getEventDetail();
    }, [router.isReady, router.query?.eid]);
    useEffect(async () => {
        if (!router.query.eid)
            return;
        additionalInfo.current = {
            cursor: null,
            hasNext: false
        };
        setProductList([]);
        await fetchProductList();
    }, [router.query?.eid, category]);
    const productListRef = useRef(null);
    useEffect(async () => {
        if (!!productListRef.current) {
            productListRef.current.scrollIntoView();
        }
    }, [category]);
    const productName = useMemo(() => {
        let name = '';
        if (productList && productList.length > 0) {
            name = productList.map(x => `[${x.brand.name}] ${x.name}`).join(', ');
        }
        return name;
    }, [productList]);
    const duration = useMemo(() => {
        let _duration = '';
        if (!Boolean(event)) {
            return _duration;
        }
        if (!Boolean(event.starts_at) && !Boolean(event.ends_at)) {
            _duration = t('EventDetail.noDate');
        }
        else {
            _duration = `${event.starts_at ? `${formatDate(event.starts_at, false)} ` : ''} - ${event.ends_at ? ` ${formatDate(event.ends_at, false)}` : ''}`;
        }
        return _duration;
    }, [event]);
    const shareLink = event ? `${SITE_URL}${getEventRoute(event.id)}` : undefined;
    const [isExpanded, setIsExpanded] = useState(previousSizeInfo.detailImageExpanded);
    const bannerDetailImageSizeRef = useRef([]);
    let isParticipationAllowed = true;
    if (event?.is_ticket_required) {
        if (event.max_participation_count <= event.participation_count)
            isParticipationAllowed = false;
    }
    else {
        if (event?.participation_count > 0)
            isParticipationAllowed = false;
    }
    const daysLeft = event && event.status === '진행중' && event.ends_at ? getDaysLeft(event.ends_at) : 0;
    const hasFixedTimerCuration = useMemo(() => {
        return event && event?.components?.some(c => (c.type === 'timer' && Boolean(c.attrs?.fixed)));
    }, [event]);
    const onSubmit = () => {
        typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailPageApplyButtonClicked', {
            eventId: event?.id,
            eventName: event?.name,
            eventStatus: event?.status,
            eventType: event?.type,
            daysLeft: daysLeft
        });
        if (event) {
            const link = event.type === KEY_TYPE_GIFT && !event.button_link ? getEventApplyRoute(event.id) : event.button_link;
            if (event.type === KEY_TYPE_GIFT) {
                router.push(link);
            }
            else {
                if (link) {
                    router.push(link);
                }
            }
        }
    };
    const onProductClick = (product, itemIdx) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailPageProductClicked', {
            eventId: event?.id,
            eventName: event?.name,
            eventStatus: event?.status,
            eventType: event?.type,
            daysLeft: daysLeft,
            productId: product.id,
            itemIdx
        });
    };
    const onLinkClick = (link, eventId) => {
        if (!link)
            return;
        typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailLinkClick', {
            link: link, eventId: eventId
        });
        if (link.startsWith('#')) {
            const componentName = link.replace('#', '');
            const component = EventDetailComponentsRef[`${event.id}_${componentName}`];
            if (component) {
                component.scrollIntoView();
            }
        }
        else {
            router.push(link);
        }
    };
    useEffect(() => {
        if (!event)
            return;
        if (!user)
            return;
        for (const button of event.detail_image_buttons) {
            if (button.type === '쿠폰' && button.requires_self_authentication && user && user.rrn) {
                const buttonClickedKey = getSelfVerificationButtonClickedLocalStorageKey(event.id, button.id);
                const buttonClicked = window.localStorage.getItem(buttonClickedKey);
                if (buttonClicked) {
                    onCouponDownload(button.coupon_mold_keys);
                    window.localStorage.removeItem(buttonClickedKey);
                }
            }
        }
    }, [event, user]);
    const { detailHour, detailSecond, detailMinute, seconds } = useTimer(bokInfo?.today_apply_ends_at);
    const getSelfVerificationButtonClickedLocalStorageKey = (eventId, buttonId) => {
        return `self_verification_clicked_${eventId}_${buttonId}`;
    };
    const onSelfVerificationClick = (eventId, buttonId, alreadyVerified) => {
        typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailSelfVerificationClick', { eventId: eventId, buttonId: buttonId, alreadyVerified: alreadyVerified });
        window.localStorage.setItem(getSelfVerificationButtonClickedLocalStorageKey(eventId, buttonId), 'true');
    };
    const onCouponDownload = async (couponMoldKeys, successMessage) => {
        if (couponMoldKeys.length > 1) {
            typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailCouponDownloadClick', { moldKey: 'all' });
        }
        else if (couponMoldKeys.length === 1) {
            typeof mixpanel !== 'undefined' && mixpanel.track('EventDetailCouponDownloadClick', { moldKey: couponMoldKeys[0] });
        }
        // setIsLoading(true);
        try {
            let res;
            if (couponMoldKeys.length === 1) {
                const data = {
                    mold_key: couponMoldKeys[0]
                };
                res = await Axios.post('v1/coupons/download', data);
            }
            else {
                const data = {
                    mold_keys: couponMoldKeys
                };
                res = await Axios.post('v1/coupons/download-bulk', data);
            }
            if (res.status < 400) {
                if (couponMoldKeys.length === 1) {
                    customAlert(successMessage || t('EventDetail.couponDownloadSuccess'), t('EventDetail.confirm'), () => { });
                }
                else {
                    if (res.data.success_count === couponMoldKeys.length) {
                        customAlert(t('EventDetail.allCouponsDownloaded'), t('EventDetail.confirm'), () => { });
                    }
                    else if (res.data.fail_count === couponMoldKeys.length) {
                        customAlert(t('EventDetail.allCouponsAlreadyDownloaded'), t('EventDetail.confirm'), () => { });
                    }
                    else {
                        customAlert(t('EventDetail.partialCouponsDownloaded', { count: res.data.success_count }), t('EventDetail.confirm'), () => { });
                    }
                }
            }
            else if (res.status === 401) {
                customConfirm(t('EventDetail.loginRequiredForCoupon'), t('EventDetail.confirm'), t('EventDetail.cancel'), () => {
                    redirectToLogin(router, true);
                }, () => { });
            }
            else {
                captureMessage(JSON.stringify(res.data));
                toast.info(res.data.display_message || t('EventDetail.couponDownloadError'));
            }
        }
        catch (e) {
            captureException(e);
            toast.info(t('EventDetail.couponDownloadError'));
        }
        finally {
            // setIsLoading(false);
        }
    };
    const isBannerSizeSaved = previousSizeInfo.bannerImageSize?.width && previousSizeInfo.bannerImageSize?.height;
    const vote = async (key) => {
        try {
            const res = await Axios.post(`v1/events/${event.id}/vote/`, { key });
            if (res.status < 400) {
                setHasVoted(res.data.has_voted);
                setVoteResult(res.data.vote_result);
                return true;
            }
            else if (res.status === 401) {
                customConfirm(t('EventDetail.loginRequiredForParticipation'), t('EventDetail.confirm'), t('EventDetail.cancel'), () => {
                    redirectToLogin(router, true);
                }, () => { });
            }
            else {
                customAlert(t('EventDetail.temporaryError'), t('EventDetail.confirm'), () => {
                });
            }
        }
        catch (e) {
            captureException(e);
            customAlert(t('EventDetail.temporaryError'), t('EventDetail.confirm'), () => {
            });
        }
    };
    const handleVoteClick = async (key) => {
        const couponKeys = event.detail_image_buttons[0]?.coupon_mold_keys || [];
        if (!hasVoted) {
            const success = await vote(key);
            if (success) {
                onCouponDownload(couponKeys, key === '퍼컬' ?
                    <Trans i18nKey="EventDetail.perColorCouponMessage" components={[<br />]}/>
                    :
                        <Trans i18nKey="EventDetail.skillCouponMessage" components={[<br />]}/>);
            }
        }
        else {
            onCouponDownload(couponKeys, key === '퍼컬' ?
                <Trans i18nKey="EventDetail.perColorCouponMessage" components={[<br />]}/>
                :
                    <Trans i18nKey="EventDetail.skillCouponMessage" components={[<br />]}/>);
        }
    };
    return (<>
            <Head>
                {router.query?.eid && router.query.eid.toString() === '925' &&
            <meta name="robots" content="noindex,nofollow"/>}
            </Head>
            <div className={classNames(utilStyles.relative, utilStyles.pageContainer)}>
                {event && event.status === STATUS_ANNOUNCED &&
            <EventResultModal isModalOpen={isResultModalOpen} close={() => setIsResultModalOpen(false)}/>}
                <div className={classNames(utilStyles.sidePadding, utilStyles.topSticky, utilStyles.whiteBackground)}>
                    <TitleBar title={t('EventDetail.title')} isBack close={() => router.back()} noTruncate renderRightButton={() => {
            return (<ShareButton shareTitle={event ? event.name : undefined} shareLink={shareLink} kakaoShareCallback={() => {
                    try {
                        Kakao.Share.sendScrap({
                            requestUrl: shareLink
                        });
                    }
                    catch (e) {
                        Sentry.captureException(e);
                    }
                }}>
                                    <ShareIcon viewBox="0 0 24 24" className={utilStyles.cursorPointer}/>
                                </ShareButton>);
        }}/>
                </div>
                {isLoading ?
            <Loading style={{ marginTop: 40, marginBottom: 60 }}/>
            :
                (event ?
                    <div className={utilStyles.relative}>
                                    {(event.description !== '20240111_luck' && event.description !== '20240118_fifo' && event.description !== '20240207_newyear_bok') &&
                            <>
                                            <div className={styles.cardImageWrapper} style={isBannerSizeSaved ? {
                                    height: 0,
                                    paddingTop: `${((previousSizeInfo.bannerImageSize.height / previousSizeInfo.bannerImageSize.width) * 100).toFixed(3)}%`,
                                    objectFit: 'cover',
                                    position: "relative"
                                } : undefined}>
                                                <img onLoad={({ target: img }) => {
                                    localStorage.setItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_IMAGE_SIZE, JSON.stringify({
                                        stateKey: window.history.state.key,
                                        width: img.width,
                                        height: img.height
                                    }));
                                }} src={event.banner_image_url} alt={event.name} className={styles.bannerImage} style={isBannerSizeSaved ? {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0
                                } : {}}/>
                                            </div>
                                            <div className={styles.infoContainer}>
                                                <div className={styles.infoRow}>
                                                    <span className={styles.infoKey}>{t('EventDetail.eventPeriod')}</span>
                                                    <TruncateMarkup lines={1} ellipsis={<span>...</span>}>
                                                    <span className={styles.infoValue}>
                                                        {duration}
                                                    </span>
                                                    </TruncateMarkup>
                                                </div>
                                                {event.type === KEY_TYPE_PROMOTION
                                    ?
                                        <>
                                                            <div className={styles.infoRow}>
                                                                <span className={styles.infoKey}>{t('EventDetail.eventContent')}</span>
                                                                <span className={styles.infoValue}>{event.description || '-'}</span>
                                                            </div>
                                                        </>
                                    :
                                        <>
                                                            {event.announce_at &&
                                                <div className={styles.infoRow}>
                                                                    <span className={styles.infoKey}>{t('EventDetail.winnerAnnouncement')}</span>
                                                                    <TruncateMarkup lines={1} ellipsis={<span>...</span>}>
                                                                        <span className={styles.infoValue}>{event.announce_at ? formatDate(event.announce_at) : '-'}</span>
                                                                    </TruncateMarkup>
                                                                </div>}
                                                            {(!!productName || event.reward_text_override) &&
                                                <div className={styles.infoRow}>
                                                                    <span className={styles.infoKey} style={{ lineHeight: '120%' }}>{t('EventDetail.providedProducts')}</span>
                                                                    {event?.description === '20240131_heveblue_event' ?
                                                        <span className={styles.infoValue} style={{ lineHeight: '120%' }}>[헤브블루] [특별이벤트] 블랙 유자 빈 밀크 클렌져</span>
                                                        :
                                                            <span className={styles.infoValue} style={{ lineHeight: '120%' }}>{event.reward_text_override || productName}</span>}
                                                                </div>}
                                                            <div className={styles.infoRow}>
                                                                <span className={styles.infoKey}>{t('EventDetail.winnerCount')}</span>
                                                                <span className={styles.infoValue}>
                                                                {event.max_participant_count ? t('EventDetail.people', { count: event.max_participant_count }) : t('EventDetail.noLimit')}
                                                                    {event.participation_count === 0 && event.status === STATUS_ANNOUNCED &&
                                                <div onClick={() => setIsResultModalOpen(true)} className={styles.resultModalButton}>{t('EventDetail.viewWinnerList')}</div>}
                                                            </span>
                                                            </div>
                                                            {event.status === STATUS_ANNOUNCED && event.participation_count > 0 &&
                                                <div className={styles.infoRow}>
                                                                    <span className={styles.infoKey}>{t('EventDetail.winningStatus')}</span>
                                                                    <div className={styles.infoValue}>
                                                                        <span className={classNames(utilStyles.brandColorText, utilStyles.bold)}>{event.is_targeted ? t('EventDetail.congratulations') : t('EventDetail.tryAgainNextTime')}</span>
                                                                        {event.participation_count > 0 &&
                                                        <div onClick={() => setIsResultModalOpen(true)} className={styles.resultModalButton}>{t('EventDetail.viewWinnerList')}</div>}
                                                                    </div>
                                                                </div>}
                                                        </>}
                                            </div>
                                        </>}
                                    {event.description === '20240207_newyear_bok' &&
                            <div className={styles.bokTimerContainer}>
                                            {seconds && seconds > 0 ?
                                    <Trans i18nKey="EventDetail.bokDrawTimeRemaining" components={[<span style={{ color: '#ff5b59' }}/>]} values={{
                                            detailHour: detailHour,
                                            detailMinute: detailMinute,
                                            detailSecond: detailSecond
                                        }}/>
                                    :
                                        <>{t('EventDetail.bokDrawTimeEnded')}</>}
                                        </div>}
                                    <div>
                                        {event.components && event.components.length > 0 &&
                            <EventDetailComponents event={event} onCouponDownload={onCouponDownload} onLinkClick={onLinkClick} isExpanded={isExpanded} hasFixedTimerCuration={hasFixedTimerCuration}/>}
                                        {event.detail_image_urls && event.detail_image_urls.length > 0 &&
                            <>
                                                {(event.description !== '20240111_luck' && event.description !== '20240118_fifo' && event.description !== '20240207_newyear_bok') &&
                                    <>
                                                        <div style={{ height: 24 }}/>
                                                        <div className={utilStyles.mobileBorder}/>
                                                    </>}
                                                <div className={styles.detailImageWrapper} style={{ marginTop: (event.description === '20240111_luck' || event.description === '20240118_fifo' || event.description === '20240207_newyear_bok') ? 0 : undefined, marginBottom: (event.description === '20240111_luck' || event.description === '20240118_fifo' || event.description === '20240207_newyear_bok') ? 0 : undefined }}>
                                                    {event.description === '20240111_luck' &&
                                    <>
                                                            <Luck event={event} setEvent={setEvent} lastLuckReward={lastLuckReward} productListRef={productListRef}/>

                                                        </>}
                                                    {event.id === 2547 &&
                                    <div className={styles.personalColorVoteContainer}>
                                                            <div className={styles.personalColorVoteBox}>
                                                                <div className={styles.personalColorVoteBoxHeader}>
                                                                    {t('EventDetail.whichMakeupPrettier')}
                                                                </div>
                                                                <div className={styles.personalColorVoteUIWrapper}>
                                                                    <div className={styles.personalColorVoteBarContainer} onClick={() => { handleVoteClick('퍼컬'); }}>
                                                                        <div className={styles.personalColorVoteBarContainerWrapper}>
                                                                            {hasVoted ?
                                            <>
                                                                                        <span className={styles.voteKey}>{t('EventDetail.perColor')}</span>
                                                                                        <span className={styles.votePercent}>{votePercentage['퍼컬'] || 0}%</span>
                                                                                        <div className={styles.voteGauge} style={{
                                                    transform: `scaleX(${(votePercentage['퍼컬'] || 0) / 100})`
                                                }}/>
                                                                                    </>
                                            :
                                                <span className={styles.textBeforeVote}>{t('EventDetail.personalColorMakeup')}</span>}
                                                                        </div>
                                                                    </div>
                                                                    <div className={styles.personalColorVoteBarContainer} onClick={() => { handleVoteClick('스킬'); }}>
                                                                        <div className={styles.personalColorVoteBarContainerWrapper}>
                                                                            {hasVoted ?
                                            <>
                                                                                        <span className={styles.voteKey}>{t('EventDetail.skill')}</span>
                                                                                        <span className={styles.votePercent}>{votePercentage['스킬'] || 0}%</span>
                                                                                        <div className={styles.voteGauge} style={{
                                                    transform: `scaleX(${(votePercentage['스킬'] || 0) / 100})`
                                                }}/>
                                                                                    </>
                                            :
                                                <span className={styles.textBeforeVote}>{t('EventDetail.oppositeColorMakeup')}</span>}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <img src={"https://d1cnx04b8cgzcv.cloudfront.net/media/events/details/a07de8e0-1952-4a04-a917-82eba95a371b_1712819355698.jpg"} className={styles.personalColorDetailImage}/>
                                                        </div>}
                                                    <div style={{ paddingBottom: 0 }}>
                                                        {((isExpanded || event.prevent_detail_images_fold) ? event.detail_image_urls : event.detail_image_urls.slice(0, 1)).map((image, idx) => {
                                    if (image === 'quiz') {
                                        return <EventDetailQuizList />;
                                    }
                                    const buttons = event.detail_image_buttons.filter(x => x.index - 1 === idx);
                                    const isDetailImageSaved = !!previousSizeInfo.detailImageSizeArray[idx]?.width && !!previousSizeInfo.detailImageSizeArray[idx]?.height;
                                    return (<div className={utilStyles.relative} key={idx} style={isDetailImageSaved ? {
                                            height: 0,
                                            paddingTop: `${((previousSizeInfo.detailImageSizeArray[idx].height / previousSizeInfo.detailImageSizeArray[idx].width) * 100).toFixed(3)}%`
                                        } : {}}>
                                                                        <LazyImage style={isDetailImageSaved ? {
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%'
                                        } : undefined} onLoad={({ target: img }) => {
                                            bannerDetailImageSizeRef.current[idx] = {
                                                width: img.width,
                                                height: img.height
                                            };
                                            localStorage.setItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_BANNER_DETAIL_SIZE, JSON.stringify({
                                                stateKey: window.history.state.key,
                                                sizes: bannerDetailImageSizeRef.current
                                            }));
                                        }} eager={idx === 0} key={idx} src={image} alt={t('EventDetail.detailImage', { idx: idx })}/>
                                                                        {buttons.length > 0 &&
                                            buttons.map(button => {
                                                const imageWidth = button.image_width;
                                                const imageHeight = button.image_height;
                                                const x1 = button.x1;
                                                const x2 = button.x2;
                                                const y1 = button.y1;
                                                const y2 = button.y2;
                                                const buttonWidth = `${(Math.abs(x2 - x1) / imageWidth * 100).toFixed(2)}%`;
                                                const buttonHeight = `${(Math.abs(y2 - y1) / imageHeight * 100).toFixed(2)}%`;
                                                const top = `${(Math.abs(y1) / imageHeight * 100).toFixed(2)}%`;
                                                const left = `${(Math.abs(x1) / imageWidth * 100).toFixed(2)}%`;
                                                return (<div onClick={() => {
                                                        if (button.type === '쿠폰' && !button.requires_self_authentication) {
                                                            onCouponDownload(button.coupon_mold_keys);
                                                        }
                                                        else if (button.type === '링크') {
                                                            onLinkClick(button.link, event.id);
                                                        }
                                                    }} key={button.id} className={classNames(utilStyles.absolute, utilStyles.cursorPointer)} style={{ zIndex: 5, top: top, left: left, width: buttonWidth, height: buttonHeight }}>
                                                                                        {button.type === '쿠폰' && !!button.requires_self_authentication &&
                                                        (!!user && !user.rrn ?
                                                            <SelfVerificationButton>
                                                                                                        <div onClick={() => { onSelfVerificationClick(event.id, button.id, false); }} style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}/>
                                                                                                    </SelfVerificationButton>
                                                            :
                                                                <div onClick={() => {
                                                                        onSelfVerificationClick(event.id, button.id, true);
                                                                        onCouponDownload(button.coupon_mold_keys);
                                                                        window.localStorage.removeItem(getSelfVerificationButtonClickedLocalStorageKey(event.id, button.id));
                                                                    }} style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}/>)}
                                                                                    </div>);
                                            })}
                                                                    </div>);
                                })}
                                                    </div>
                                                    {event.description === '20240118_fifo' &&
                                    <Fifo event={event}/>}
                                                    {event.detail_image_urls.length > 1 && !event.prevent_detail_images_fold &&
                                    <div className={styles.expandButtonWrapper}>
                                                            <div className={styles.expandButton} onClick={() => {
                                            setIsExpanded(val => !val);
                                            localStorage.setItem(LOCAL_STORAGE_KEY_EVENT_DETAIL_DETAIL_IMAGE_EXPANDED, JSON.stringify({
                                                stateKey: window.history.state.key,
                                                isExpanded: true
                                            }));
                                        }}>
                                                                {isExpanded ? t('EventDetail.collapseDetails') : t('EventDetail.expandDetails')}
                                                                <ArrowDown viewBox="0 0 24 24" width="20" height="20" style={{ transform: isExpanded ? "scaleY(-1)" : null }}/>
                                                            </div>
                                                        </div>}
                                                </div>
                                                {event.description === '20240111_luck' &&
                                    <div style={{
                                            marginBottom: 24,
                                            width: '100%',
                                            height: 0,
                                            paddingTop: '64.33%',
                                            backgroundImage: 'url(https://d1cnx04b8cgzcv.cloudfront.net/luck/warning.png)',
                                            backgroundSize: 'contain',
                                            backgroundRepeat: 'no-repeat'
                                        }}/>}
                                                {event.description === '20240207_newyear_bok' &&
                                    <Bok event={event} bokInfo={bokInfo}/>}
                                            </>}
                                        {<div className={styles.productListContainer} ref={productListRef}>
                                                <div className={utilStyles.mobileBorder}/>
                                                <StoreNavBar replace={true} changeQueryParamOnly noSubCategoryMarginBottom maintainScroll stickyTop={hasFixedTimerCuration && 90}/>
                                                {productList && productList.length > 0 && event.description !== '20240207_newyear_bok' &&
                                <div className={styles.contentSection}>
                                                        <InfiniteScroll scrollThreshold={'80%'} hasMore={!!additionalInfo.current.hasNext} dataLength={productList.length} next={fetchProductList} style={{ overflow: 'hidden' }} loader={<div></div>}>
                                                            <Row className={styles.row}>
                                                                {productList.map((e, idx) => {
                                        return (<Col key={e.id} xs={6} className={styles.col}>
                                                                                <ProductListCard product={e} onClick={() => onProductClick(e, idx)} textPaddingType="medium"/>
                                                                            </Col>);
                                    })}
                                                            </Row>
                                                        </InfiniteScroll>
                                                    </div>}
                                            </div>}
                                        {(event.type === KEY_TYPE_GIFT || event.button_link) && (event.status === STATUS_IN_PROGRESS || event.is_button_permanent) && event.description !== '20240118_fifo' && event.description !== '20240207_newyear_bok' &&
                            <div className={classNames(styles.buttonWrapper, event.description === '20240111_luck' ? styles.luckButtonWrapper : undefined)}>
                                                {event.description === '20240111_luck' ?
                                    <Trans i18nKey="EventDetail.remainingLuckDraws" components={[<span className={styles.emphasize}/>]} values={{
                                            count: event.max_participation_count - event.participation_count
                                        }}/>
                                    :
                                        <div>
                                                            <FullButton onClick={onSubmit} disabled={!isParticipationAllowed} title={((event.is_ticket_required && (event.max_participation_count > event.participation_count || event.max_participation_count === 0)) ||
                                                (!event.is_ticket_required && event.participation_count === 0) ? (event.button_text || t('EventDetail.participate')) : t('EventDetail.participationComplete'))
                                                + (event.is_ticket_required ?
                                                    `(${event.participation_count}/${event.max_participation_count})`
                                                    :
                                                        '')} fontSize={16} height={48} light={!isParticipationAllowed} noCursor={!isParticipationAllowed}/>
                                                        </div>}
                                            </div>}
                                    </div>
                                </div>
                    :
                        <div></div>)}
            </div>
        </>);
};
EventDetail.getLayout = NavigationLayout;
export default EventDetail;
EventDetail.restoreScroll = true;

    async function __Next_Translate__getServerSideProps__1964211f498__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/events/[eid]/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1964211f498__ as getServerSideProps }
  